import React, {SVGProps} from 'react';

export const EditSquareIcon: React.FC<SVGProps<any>> = props => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M4.86435 7.61085C4.77649 7.6987 4.72006 7.81299 4.70292 7.93655L4.26006 11.1159C4.23577 11.2945 4.29577 11.4737 4.42363 11.6002C4.55149 11.7266 4.73078 11.7859 4.90862 11.7602L8.06784 11.2966C8.18927 11.2787 8.30212 11.2223 8.38927 11.1352L15.6536 3.87079C16.1108 3.41365 16.1108 2.6558 15.6536 2.19937L13.8015 0.34721C13.3443 -0.109933 12.5858 -0.110646 12.1293 0.345781L4.86435 7.61085Z"
        fill="black"
      />
      <path
        d="M1.71429 0C0.77429 0 0 0.77429 0 1.71429V14.2857C0 15.2257 0.77429 16 1.71429 16H14.2857C15.2257 16 16 15.2257 16 14.2857V7.98574C16 7.83431 15.94 7.68859 15.8329 7.58146C15.7257 7.47432 15.58 7.41432 15.4286 7.41432C15.1129 7.41432 14.8572 7.67002 14.8572 7.98574V14.2857C14.8572 14.6122 14.6122 14.8572 14.2857 14.8572H1.71429C1.38786 14.8572 1.14286 14.6122 1.14286 14.2857V1.71429C1.14286 1.38786 1.38786 1.14286 1.71429 1.14286H8.00001C8.15143 1.14286 8.29715 1.08287 8.40429 0.975722C8.51143 0.868579 8.57143 0.722867 8.57143 0.571443C8.57143 0.420019 8.51143 0.2743 8.40429 0.167164C8.29714 0.060021 8.15143 2.19727e-05 8.00001 2.19727e-05L1.71429 0Z"
        fill="black"
      />
    </svg>
  );
};
